export const LegacyPoleForemanFieldIds = {
	TRANSMISSION_POLE: 'transmissionPole',
	ANCHOR_GUY_STRUT_HEIGHT: 'guyStrutHeight',
	FRAMING_TYPE: 'framingType',
	RULING_SPAN: 'rulingSpan',
	PHASE_A_HEIGHT: 'phaseAHeight',
	PHASE_B_HEIGHT: 'phaseBHeight',
	PHASE_C_HEIGHT: 'phaseCHeight',
} as const;
